module.exports = __webpack_public_path__ + "testimonial-logo-fannie-mae.ROwkbEWu.svg";